import { render, staticRenderFns } from "./SelectStatusModal.vue?vue&type=template&id=5a72a364&scoped=true"
import script from "./SelectStatusModal.vue?vue&type=script&lang=ts"
export * from "./SelectStatusModal.vue?vue&type=script&lang=ts"
import style0 from "./SelectStatusModal.vue?vue&type=style&index=0&id=5a72a364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a72a364",
  null
  
)

export default component.exports